import React from "react";

export const Title = ({ name, scanCopyFax }) => {
  if (scanCopyFax == true) {
    return (
      <h1 className="text-center text-sm-start">
        PrintWithMe Print, Scan, Copy, and Fax Station at{" "}
        <span className="fst-italic">{name}</span>
      </h1>
    );
  }

  return (
    <h1 className="text-center text-sm-start">
      PrintWithMe Printing Station at <span className="fst-italic">{name}</span>
    </h1>
  );
};
